export default "__VITE_ASSET__DkmHrr3P__"